<template>
  <div class="card row cardBemVindo">
      <div class="col-12">
          <h4>{{ $t('Tipo de OS') }}</h4>
          <p>{{ $t('Atendidas nos últimos 30 dias') }}</p>
          <div class="progress-container">
              <!-- Iterando sobre os tipos de OS -->
              <div class="progress-row" v-for="(item, index) in getTipoOrdem" :key="index">
                  <div class="description">{{ $t(item.tipo) }} - Qtd: {{ item.quantidade_os }}</div>
                  <div class="d-flex align-items-center">
                    <div class="progress-bar">
                        <div class="progress-fill"
                             :style="{ width: calculatePercentage(item.quantidade_os) + '%' }"
                             :class="getBarColor(item.tipo)">
                        </div>
                    </div>
                    <div class="percentage">{{ calculatePercentage(item.quantidade_os) }}%</div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
data() {
  return {
    totalOS: 0, // Total de OS para calcular as porcentagens
  }
},

computed: {
  getTipoOrdem() {
    const tipoOrdem = this.$store.getters['dashboard/getTipoOrdem'];

    if (!tipoOrdem) {
      this.$store.dispatch('dashboard/getTipoOrdem');
      return [];
    }

    return tipoOrdem.getTipoOrdem;
  }
},
 
mounted() {
  this.$store.dispatch('dashboard/getTipoOrdem').then(() => {
    this.calculateTotalOS();
  });
},

methods: {
  // Calcula o total de OS
  calculateTotalOS() {
    const tipoOrdem = this.$store.getters['dashboard/getTipoOrdem'];

    if (tipoOrdem) {
      this.totalOS = tipoOrdem.getTipoOrdem.reduce((total, item) => total + item.quantidade_os, 0);
    }
  },

  // Calcula a porcentagem
  calculatePercentage(quantidadeOS) {
    return ((quantidadeOS / this.totalOS) * 100).toFixed(2);
  },

  // Define a cor da barra com base no tipo de OS
  getBarColor(tipo) {
    const colors = {
      'PROATIVA': 'blue',
      'CORRETIVA': 'green',
      'SOCORRO EM ROTA': 'red',
      'ALINHAMENTO DE EIXOS': 'orange',
    };
    return colors[tipo] || 'blue'; // Padrão é azul caso não tenha cor definida
  }
}
}
</script>

<style scoped>
.cardBemVindo {
  margin-right: 10px;
}

/* Estilos principais para o container */
.progress-container {
width: 100%;
max-width: 600px;
margin: 0 auto;
height: 310px;
overflow: auto;
padding-right: 15px;
}

/* Estilos para cada linha de progresso */
.progress-row {
/* display: flex; */
align-items: center;
margin-bottom: 28px;
}

.description {
flex: 1;
font-size: 16px;
font-weight: bold;
margin-right: 10px;
}

/* Barra de progresso */
.progress-bar {
flex: 4;
background-color: #e0e0e0;
border-radius: 10px;
position: relative;
height: 15px;
margin-right: 10px;
overflow: hidden;
}

/* Preenchimento da barra */
.progress-fill {
height: 100%;
border-radius: 10px;
}

/* Cores diferentes para cada barra */
.blue {
background-color: #3498db;
}

.green {
background-color: #2ecc71;
}

.red {
background-color: #e74c3c;
}

.orange {
background-color: #f39c12;
}

/* Estilo da porcentagem */
.percentage {
font-size: 16px;
font-weight: bold;
}
</style>
